import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getOne, update } from './../../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { EditPage, EditPagePanel, EditPageTextField, EditPageSelect, EditPageCheckbox } from './../../../../common/EditPage';


const CarrierVoiceAccountEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const carrierId = useParams().carrier_id;
    const voiceaccountId = useParams().voiceaccount_id;
    const navigate = useNavigate();

    useEffect(() => {
        getOne(`/admin/carriers/carriers/${carrierId}/voiceaccounts/`, voiceaccountId)
            .then(response => {
                setData(response.data.data);
                setMetadata(response.data.metadata);
            })
            .catch(error => {
                toast.error("Error loading voice account: " + error.message, {});
            });
    }, [carrierId, voiceaccountId]);

    const handleSave = () => {
        update(`/admin/carriers/carriers/${carrierId}/voiceaccounts/`, voiceaccountId, {data: data}).then(response => {
            toast.success("Voice account updated successfully", {});
            navigate(`/carriers/carriers/${carrierId}/voiceaccounts`);
        }).catch(error => {
            toast.error("Error updating voice account: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate(`/carriers/carriers/${carrierId}/voiceaccounts`);
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } >
                <EditPagePanel>
                    <EditPageSelect label="Authentication Type" id="ATRAUTHTYPEID" onChange={ onChange } value={ data.ATRAUTHTYPEID } options={ metadata?.auth_types?.values } />
                    <EditPageTextField label="Name" id="ATRALIAS" onChange={ onChange } value={ data.ATRALIAS } />
                    <EditPageTextField label="IP Address" id="ATRIPADDR" onChange={ onChange } value={ data.ATRIPADDR } />
                    <EditPageTextField label="Port" id="port" onChange={ onChange } value={ data.port } />
                    <EditPageTextField label="Prefix" id="ATRPREFIX" onChange={ onChange } value={ data.ATRPREFIX } />
                    <EditPageSelect label="Rate Profile" id="ATRPRODUCTID" onChange={ onChange } value={ data.ATRPRODUCTID } options={ metadata?.products?.values } />
                    <EditPageSelect label="Caller ID Group" id="caller_id_rewrite_group_id" onChange={ onChange } value={ data.caller_id_rewrite_group_id } options={ metadata?.callerIdGroups?.values } />
                    <EditPageCheckbox label="Enabled" id="ATRSTATUS" onChange={ onChange } value={ data.ATRSTATUS } />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default CarrierVoiceAccountEdit;